/**
 * Synthetic patient ID used by the in-app tutorial. Lives outside the real
 * patient UUID space so any leak to the backend is loud (Postgres rejects
 * it as 22P02 → 500 on `/patient/get`, `/patient/update`, etc.).
 *
 * The fetch-layer guards in APIService and auth0BaseQuery short-circuit
 * any outgoing request that references this ID — see GDN-1426 for the
 * reasoning behind the centralized guard vs. per-callsite `isTutorialMode`
 * checks.
 */
export const TUTORIAL_PATIENT_ID = 'tutorial-patient-123';

/**
 * Inspect arbitrary fetch / RTK Query args (URL, params object, body) for
 * the tutorial patient ID. Stringifies safely: a JSON body, a plain object,
 * or a URLSearchParams-style record all match.
 */
export const containsTutorialPatientId = (...values: unknown[]): boolean => {
  for (const value of values) {
    if (value == null) continue;
    if (typeof value === 'string') {
      if (value.includes(TUTORIAL_PATIENT_ID)) return true;
      continue;
    }
    try {
      if (JSON.stringify(value).includes(TUTORIAL_PATIENT_ID)) return true;
    } catch {
      // Unserializable args (circular refs, etc.) cannot encode the literal.
    }
  }
  return false;
};
